import { Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  createLocation,
  deleteLocationById,
  getLocations,
  updateLocationById,
} from "../../../redux/reducers/clinicSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { locationTypes } from "../../../util/dropList";

const initValues = { locationName: "", locationType: [], assignTo: null };
const initErrs = { locationName: false, locationType: false, assignTo: false };
const initHlps = { locationName: "", locationType: "", assignTo: "" };

const tableHeaders = ["locationName", "locationTypes", "extraStatus"];

const Location = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [modVsble, setModVsble] = useState(false);
  const [delModVsble, setDelModVsble] = useState(false);
  const [locationValues, setLocationValues] = useState(initValues);
  const [locationErrors, setLocationErrors] = useState(initErrs);
  const [locationHelps, setLocationHelps] = useState(initHlps);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const locations = useSelector((state) => state?.clinic?.locations);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);

  useEffect(() => {
    dispatch(getLocations());
    dispatch(getClinicVets());
  }, []);

  const handleCreate = () => {
    setModVsble(true);
  };

  const handleModClose = () => {
    setModVsble(false);
    setLocationValues(initValues);
    setLocationErrors(initErrs);
    setLocationHelps(initHlps);
    setSelectedLocation(null);
  };

  const handleChange = (name, value) => {
    setLocationValues({ ...locationValues, [name]: value });
    setLocationErrors({ ...locationErrors, [name]: value?.length === 0 });
    setLocationHelps({
      ...locationHelps,
      [name]: value?.length === 0 ? "This is required field" : "",
    });
  };

  const handleEdit = (loc) => {
    const reqObj = {
      ...locationValues,
      locationName: loc?.locationName,
      locationType: loc?.mainLocation,
    };
    if (loc?.assignTo) {
      const reqVet = getVetList()?.find((li) => li?.doctorId === loc?.assignTo);
      if (reqVet) reqObj.assignTo = reqVet;
    }
    setLocationValues(reqObj);
    setSelectedLocation(loc);
    setModVsble(true);
  };

  const handleDelete = (loc) => {
    setSelectedLocation(loc);
    setDelModVsble(true);
  };

  const getTableLocations = () => {
    return locations?.map((loc) => ({
      ...loc,
      locationTypes: loc?.mainLocation?.join(", "),
      extraStatus: (
        <div className="flex-row">
          <img
            src={require("../../../assets/images/png/delete.png")}
            alt=""
            className="imghw30 cursor"
            onClick={() => handleDelete(loc)}
          />

          <img
            src={require("../../../assets/images/png/editNew.png")}
            alt=""
            className="ml10 imghw30 cursor"
            onClick={() => handleEdit(loc)}
          />
        </div>
      ),
    }));
  };

  const handleValidate = () => {
    let errObj = {};
    let hlpObj = {};
    Object.keys(locationValues).forEach((key) => {
      if (locationValues?.[key]?.length === 0 || !locationValues?.[key]) {
        errObj = {
          ...errObj,
          [key]:
            key === "assignTo"
              ? locationValues?.locationType?.includes("At-Home")
                ? true
                : false
              : true,
        };
        hlpObj = {
          ...hlpObj,
          [key]:
            key === "assignTo"
              ? locationValues?.locationType?.includes("At-Home")
                ? "This is required field"
                : ""
              : "This is required field",
        };
      }
    });
    setLocationErrors({ ...locationErrors, ...errObj });
    setLocationHelps({ ...locationHelps, ...hlpObj });
    return Object.values(errObj)?.some((err) => err === true);
  };

  const handleSave = () => {
    if (handleValidate()) return;
    const data = {
      locationName: locationValues?.locationName,
      mainLocation: locationValues?.locationType,
    };
    if (locationValues?.locationType?.includes("At-Home")) {
      data.assignTo = locationValues?.assignTo?.doctorId;
    }
    if (selectedLocation) {
      dispatch(
        updateLocationById({ locationId: selectedLocation?.id, data })
      ).then((res) => {
        if (res?.payload) {
          dispatch(getLocations());
          handleModClose();
        }
      });
    } else {
      dispatch(createLocation(data)).then((res) => {
        if (res?.payload) {
          dispatch(getLocations());
          handleModClose();
        }
      });
    }
  };

  const handleCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedLocation(null);
  };

  const handleDeleteLocation = () => {
    dispatch(deleteLocationById(selectedLocation?.id)).then((res) => {
      if (res?.payload) {
        dispatch(getLocations());
        handleCloseDelMod();
      }
    });
  };

  const getVetList = () => {
    return clinicVets?.filter((vl) => {
      if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
        return vl;
      }
    });
  };

  return (
    <Container maxWidth="xl">
      <div className="com-mar back-white pv10">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="flex-row-center"
        >
          <div className="flex-row">
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ width: "600px" }}
            >
              <CustomTextField
                placeholder="Search"
                fullWidth
                backgroundColor={AppColors.lightPink}
                value={searchValue}
                handleChange={(e) => setSearchValue(e.target.value)}
              />
            </Grid>
          </div>
          <div className="w5Per ml20">
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <div>
                <CustomButton text="Create" smallBtn onClick={handleCreate} />
              </div>
            </Grid>
          </div>
        </Grid>

        <CustomTable columns={tableHeaders} datas={getTableLocations()} grey />
      </div>

      <CustomModal
        open={modVsble}
        onClose={handleModClose}
        header={selectedLocation ? "Edit" : "Create"}
        modalWidth={30}
        rightModal
      >
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Location Name <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="locationName"
              fullWidth
              value={locationValues?.locationName}
              error={locationErrors?.locationName}
              helperText={locationHelps?.locationName}
              handleChange={(e) =>
                handleChange("locationName", e?.target?.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Location Type <span className="red-color">*</span>
            </div>
            <CustomSelect
              list={locationTypes}
              value={locationValues?.locationType}
              error={locationErrors?.locationType}
              helperText={locationHelps?.locationType}
              handleChange={(e) =>
                handleChange("locationType", e?.target?.value)
              }
              multiSelectTagCheck
            />
          </Grid>
          {locationValues?.locationType?.includes("At-Home") ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Assign To <span className="red-color">*</span>
              </div>
              <CustomSelect
                list={getVetList()}
                value={locationValues?.assignTo}
                handleChange={(e, value) => handleChange("assignTo", value)}
                name="assignTo"
                search
                error={locationErrors?.assignTo}
                helperText={locationHelps?.assignTo}
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex1-end mt10">
              <div>
                <CustomButton
                  text={selectedLocation ? "Update" : "Submit"}
                  smallBtn
                  onClick={handleSave}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>

      <CustomModal
        open={delModVsble}
        onClose={handleCloseDelMod}
        header="Delete Location"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the supplier?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleDeleteLocation}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </Container>
  );
};

export default Location;
